import React from 'react';

import Snackbar from '@mui/material/Snackbar';

import aampeTheme from '../../constants/aampeTheme';

interface BaseSnackBarProps {
    Icon: any;
    title: string;
    color: string;
    bgColor: string;
    autoHideDuration: number | undefined;
    open?: boolean;
    handleClose?: () => void;
}

const BaseSnackBar: React.FC<React.PropsWithChildren<BaseSnackBarProps>> = ({
    Icon,
    title,
    color,
    bgColor,
    autoHideDuration = 2000,
    handleClose,
    open = true,
}) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: aampeTheme.borderRadius.default,
                    marginBottom: aampeTheme.spacing4(4),
                    backgroundColor: bgColor,
                    color: color,
                    width: '100%',
                    padding: aampeTheme.spacing4(2, 12),
                }}
            >
                <Icon
                    style={{
                        fontSize: '22px',
                        marginRight: aampeTheme.spacing4(2),
                    }}
                />
                {title}
            </div>
        </Snackbar>
    );
};

export default BaseSnackBar;
